import { useCurrentRoute } from '@office-start/component-context-service';
import { usePrefetchAccessToken } from '@office-start/create-document-service';
import { LazyFeature, PageUnstyled, } from '@office-start/office-home-app-shared';
import { convertRawPageToPageName } from '@office-start/telemetry-utility';
import React, { lazy, useEffect } from 'react';
import { navigateToCreateNew } from './navigateToCreateNew';
var StartPageLazy = lazy(function () {
    return import(
    /* webpackChunkName: "startpage" */ '@office-start/start-page-component');
});
var StorageErrorMessageBar = lazy(function () {
    return import(
    /* webpackChunkName: "semb" */ '@office-start/storage-error-messagebar-component');
});
export var StartPage = function (scrollContentRef, appQuery, templateId) {
    var StartPageInternal = function () {
        var currentRoute = useCurrentRoute();
        if (!currentRoute || !currentRoute.app) {
            // $TODO: Log an error when no app is found
            // $TODO: Show an error and redirect to home?
            return React.createElement("div", null, "Unable to load application.");
        }
        if (appQuery) {
            return (React.createElement(StartPageWithQuery, { appQuery: appQuery, templateId: templateId }));
        }
        else {
            return (React.createElement(PageUnstyled, { errorEventName: currentRoute.app, name: convertRawPageToPageName(currentRoute.app + 'Start') },
                React.createElement(LazyFeature, null,
                    React.createElement(StorageErrorMessageBar, null),
                    React.createElement(StartPageLazy, { configId: currentRoute.app, context: { scrollContentRef: scrollContentRef } }))));
        }
    };
    return StartPageInternal;
};
var StartPageWithQuery = function (_a) {
    var appQuery = _a.appQuery, templateId = _a.templateId;
    var prefetchedToken = usePrefetchAccessToken();
    useEffect(function () {
        // Call navigateToCreateNew when the component mounts
        navigateToCreateNew(appQuery, templateId, prefetchedToken);
    }, [appQuery, templateId, prefetchedToken]);
    return null; // Return null or loading indicator while navigating
};
//# sourceMappingURL=StartPage.js.map